import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import TheMask from 'vue-the-mask';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';

import dayjs from '@/plugins/dayjs';
import vmoney from '@/plugins/vmoney';

import { createPinia } from 'pinia';

const pinia = createPinia();

const appName = import.meta.env.VITE_APP_NAME || 'Terminal Kadıköy';

// Debug: Chrome'da ne olduğunu görmek için
console.log('[APP.JS] Script loaded, readyState:', document.readyState);
console.log('[APP.JS] Body exists:', !!document.body);
console.log('[APP.JS] Inertia element exists:', !!document.querySelector('[data-page]'));

// Inertia app'i başlat
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        console.log('[APP.JS] Inertia setup called, el:', el);
        if (!el) {
            console.error('[APP.JS] Inertia mount element is null in setup');
            return null;
        }
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(pinia)
            .use(ZiggyVue)
            .use(TheMask)
            .use(dayjs)
            .use(vmoney)
            .mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});

console.warn = () => {};
